module.exports = __webpack_public_path__ + "img/efficiency-reports.abefe8e1.png";